import { ReactNode, useEffect } from 'react';

import * as Sentry from '@sentry/react';
import { FlagsmithClientProvider } from '@openfeature/flagsmith-client-provider';
import { OpenFeatureProvider } from '@openfeature/react-sdk';
import { OpenFeature } from '@openfeature/web-sdk';

type Props = { children: ReactNode };

const ENVIRONMENT_ID = import.meta.env.VITE_FLAGSMITH_ENVIRONMENT_ID;

let registrationStarted = false;

const registerFlagsmith = async (): Promise<void> => {
  if (registrationStarted) return;
  registrationStarted = true;

  if (!ENVIRONMENT_ID) {
    Sentry.captureMessage(
      'Flagsmith disabled: VITE_FLAGSMITH_ENVIRONMENT_ID is not set. Flag evaluations will return defaults.',
      'warning',
    );
    return;
  }

  try {
    await OpenFeature.setProviderAndWait(
      new FlagsmithClientProvider({ environmentID: ENVIRONMENT_ID }),
    );
  } catch (err) {
    Sentry.captureException(err);
  }
};

export const FeatureFlagsProvider = ({ children }: Props) => {
  useEffect(() => {
    void registerFlagsmith();
  }, []);

  return <OpenFeatureProvider>{children}</OpenFeatureProvider>;
};
